import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import React, { memo } from "react";
import { UserMention } from "~/components/Discussions/UserMention/UserMention";
import Linkify from "~/components/Linkify";
import { uuidRegExpString } from "~/utils/Url";
// Captures mentions in the style of '@[First Last](UUID)'
// Same as react-mentions, this pattern matching assumes no parentheses and
// brackets in user names.
const MentionRegExp = /(@\[[^()]*\]\([^()]*\))/;
const MentionNameRegExp = /\[(.*)\]/;
const MentionIdRegExp = new RegExp(".*(".concat(uuidRegExpString, ").*"), "i");
export const CommentDisplay = /*#__PURE__*/ memo((param)=>{
    let { className, text, ["data-testid"]: testId, metadata, mentionsList = [] } = param;
    return /*#__PURE__*/ _jsx(Linkify, {
        renderLink: (props)=>/*#__PURE__*/ _jsx("a", {
                ...props,
                target: "_blank",
                rel: "noreferrer"
            }),
        children: /*#__PURE__*/ _jsx("div", {
            className: tailwindMerge("whitespace-pre-wrap text-14 text-grey-11", className),
            "data-testid": testId,
            children: text.split(MentionRegExp).map((str, index)=>{
                if (index === 0 && metadata) {
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            metadata,
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-14 text-grey-12",
                                children: str
                            })
                        ]
                    }, index);
                }
                if (str.match(MentionRegExp)) {
                    var _str_match, _str_match1;
                    var _str_match_;
                    const userName = (_str_match_ = (_str_match = str.match(MentionNameRegExp)) === null || _str_match === void 0 ? void 0 : _str_match[1]) !== null && _str_match_ !== void 0 ? _str_match_ : "Anonymous";
                    const userId = (_str_match1 = str.match(MentionIdRegExp)) === null || _str_match1 === void 0 ? void 0 : _str_match1[1];
                    const mentionedUser = mentionsList.find((param)=>{
                        let { id } = param;
                        return id === userId;
                    });
                    return /*#__PURE__*/ _jsx(UserMention, {
                        userName: userName,
                        user: mentionedUser
                    }, index);
                }
                return str;
            })
        })
    });
});
CommentDisplay.displayName = "CommentDisplay";
